import { render, staticRenderFns } from "./CornerPoints.vue?vue&type=template&id=d1679904&scoped=true&"
import script from "./CornerPoints.vue?vue&type=script&lang=js&"
export * from "./CornerPoints.vue?vue&type=script&lang=js&"
import style0 from "./CornerPoints.vue?vue&type=style&index=0&id=d1679904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1679904",
  null
  
)

export default component.exports